// returns a binder to change properties of an element
export default function prop(propertyName, mappingFn) {
  return {
    on: null,
    getValue: function getValue() {
      return this[propertyName];
    },
    setValue: function setValue(value) {
      var val = typeof mappingFn === 'function' ? mappingFn(value) : value;
      try {
        this[propertyName] = val;
      } catch (_unused) {
        // the property is read-only (eg tagName)
      }
    }
  };
}